// Solta os cliques de ação que o hold_action_clicks.js (inline no <head>) segurou enquanto o
// application.js carregava. Fica depois do sweet-alert-confirm no application.js. O jquery.turbolinks
// dispara os callbacks de $(fn) em sequência, na ordem em que foram registrados; o setTimeout deixa
// o clique para depois de todos eles (os scripts de cada página também ligam handlers no ready), e
// o handler do gem já ligou a confirmação quando este roda. Nos layouts sem a trava (login, OAuth),
// não faz nada.
if (window.hospedinActionClicks) window.hospedinActionClicks.scriptsLoaded = true;

jQuery(function () {
  setTimeout(function () {
    if (window.hospedinActionClicks) window.hospedinActionClicks.release();
  }, 0);
});
